@if (config$ | async; as config) {
  <vex-base-layout
    [class.hidden]="(authenticatedLoadingCoordinator.shouldShowLoadingScreen$ | async)">
    <vex-progress-bar></vex-progress-bar>
    <vex-search></vex-search>
    <mat-sidenav-container class="vex-layout-sidenav-container">
      <!-- Main Navigation Sidenav -->
      <!-- Pas d'`autosize` sur le conteneur : il rebrancherait
           `updateContentMargins()` sur chaque cycle de détection, et le contenu
           suivrait le rail au lieu de rester en place pendant le survol. -->
      <mat-sidenav
        (closedStart)="onSidenavClosed()"
        class="vex-layout-sidenav-drawer"
        [class.vex-sidenav-rail-open]="!!(sidenavRailHoverOpen$ | async)"
        [disableClose]="!!(sidenavDisableClose$ | async)"
        [fixedInViewport]="!!(sidenavFixedInViewport$ | async)"
        [mode]="(sidenavMode$ | async) ?? 'side'"
        [opened]="!!(sidenavOpen$ | async)"
        position="start">
        <vex-sidenav [collapsed]="!!(sidenavCollapsed$ | async)"></vex-sidenav>
      </mat-sidenav>
      <!-- Contextual Navigation is now integrated into the main sidenav -->
      <!-- Quickpanel -->
      <mat-sidenav (closedStart)="onQuickpanelClosed()"
        [opened]="!!(quickpanelOpen$ | async)"
        class="vex-layout-quickpanel"
        mode="over"
        position="end">
        <vex-quickpanel></vex-quickpanel>
      </mat-sidenav>
      <mat-sidenav-content
        class="vex-layout-sidenav-content">
        <!-- Toolbar with burger menu button -->
        <vex-toolbar></vex-toolbar>
        <main class="vex-layout-content">
          <app-usage-limit-banner></app-usage-limit-banner>
          <!-- Breadcrumbs-only fallback bar: fills the reserved header strip on
               pages that don't render their own secondary toolbar, so the header
               (and the breadcrumb trail) stays consistent everywhere. -->
          @if (!toolbarPresence.present()) {
            <vex-secondary-toolbar [fallback]="true"></vex-secondary-toolbar>
          }
          <router-outlet></router-outlet>
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </vex-base-layout>

  <!--
    No support bubble here. It was withdrawn from the manager shell: this
    surface already carries a floating panel trigger, and a second permanent
    disc in the bottom-right corner sat on top of page content. The Support tab
    of the docked panel is still reached by the notification deep-link
    (`/?support=<id>`, see `SupportStore.requestOpen`) and by `/help/contact`.
    The tenant portal keeps its bubble — see `tenant-shell.component.ts`, where
    it is stacked above the emergency button.
  -->
}
